import { Service } from '@roc/feature-app-core';

const url = {
  GET_AVAILABLE_TASKS_BY_DRAW_ID:
    '/api/v1/loan/mobile_v2/pointOfContact/getAvailableTasksByDrawId',
  GET_POINT_OF_CONTACTS_BY_LOAN_ID:
    '/api/v1/loan/mobile_v2/pointOfContact/getPointOfContactsByLoanId',
  ASSIGN_TASK: '/api/v1/loan/mobile_v2/pointOfContact/assignTask',
  GET_POINT_OF_CONTACT_BY_INVITE_CODE:
    '/api/v1/loan/public/mobile_v2/pointOfContact/getPointOfContactByInviteCode',
  GET_POINT_OF_CONTACT_TASKS:
    '/api/v1/loan/public/mobile_v2/pointOfContact/getPointOfContactTasks',
  GET_LENDER_BY_ID: '/nportal/rest/priv/lender/getLenderById',
};

export class PointOfContactService extends Service {
  getAvailableTasksByDrawId(drawId: number) {
    return this.get(url.GET_AVAILABLE_TASKS_BY_DRAW_ID, { drawId });
  }

  getPointOfContactsByLoanId(loanId: number, type: string) {
    return this.get(url.GET_POINT_OF_CONTACTS_BY_LOAN_ID, { loanId, type });
  }

  assignTask(data: object) {
    return this.post(url.ASSIGN_TASK, data);
  }

  getLenderById(lenderId) {
    return this.get(url.GET_LENDER_BY_ID, { lenderId });
  }
}
